import { pepperClient } from "@/lib/request";

/**
 * 搜索词请求参数
 */
export interface GuessSearchRequestParams {
  selectCityId?: number; // 选择城市Id
  cityId?: number; // 选择城市Id
  userId?: number; // 用户Id
  _ver: string; // 版本号
  platform: number; // 平台
  lat?: number; // 纬度
  lng?: number; // 经度
  useForPrompt: boolean; // 是否用于文案提示
  wxOpenId?: string; // 微信openid
  fromHome: boolean; // 是否从首页进入
  sourceFlagCode: number; // 来源标识码，写死16
  channelSource: string; // 渠道来源，写死search
}

/**
 * 搜索词响应数据
 */
export interface GuessSearchData {
  searchWords: Array<{
    word: string;
  }>
}

/**
 * 获取搜索词
 * @param params 请求参数
 */
export async function getGuessSearch(params: GuessSearchRequestParams) {
  return pepperClient.get<GuessSearchRequestParams>({
    url: "/api/product/mtlj/guessSearch",
    data: params,
  });
}

